<template>
  <a :href="lineAddUrl" @click="updateLineAddedStatus" @mouseover="updateLineAddedStatus">
    <img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="友だち追加" height="36" border="0">
  </a>
</template>

<script>
export default {
  data() {
    return {
      lineAddUrl: process.env.VUE_APP_LINE_FRIEND_ADD_URL || "https://lin.ee/b0bLXY4",
    }
  },
  methods: {
    updateLineAddedStatus() {
      this.$emit('updateLineAddedStatus')
    }
  }
};
</script>